import api from './api';

export const productsService = {
  // Categories
  categories: {
    getAll: async () => {
      const response = await api.get('/categories');
      return response.data;
    },

    create: async (data) => {
      const response = await api.post('/categories', data);
      return response.data;
    },

    update: async (categoryId, data) => {
      const response = await api.put(`/categories/${categoryId}`, data);
      return response.data;
    },

    delete: async (categoryId) => {
      const response = await api.delete(`/categories/${categoryId}`);
      return response.data;
    },

    getPublicStats: async () => {
      const response = await api.get('/public/category-stats');
      return response.data;
    },
  },

  // Products (Public/Shared)
  products: {
    getAll: async (categoryId) => {
      const params = categoryId ? `?category_id=${categoryId}` : '';
      const response = await api.get(`/products${params}`);
      return response.data;
    },
  },

  // Managed Products (Unified Admin/Reseller Endpoint)
  adminProducts: {
    getAll: async (params = {}) => {
      // Build query string from all provided params dynamically
      const queryParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value);
        }
      });
      const queryStr = queryParams.toString() ? `?${queryParams.toString()}` : '';

      const response = await api.get(`/admin/products${queryStr}`);
      return response.data;
    },

    create: async (data) => {
      const response = await api.post('/admin/products', data);
      return response.data;
    },

    update: async (productId, data) => {
      const response = await api.put(`/admin/products/${productId}`, data);
      return response.data;
    },

    delete: async (productId) => {
      const response = await api.delete(`/admin/products/${productId}`);
      return response.data;
    },
  },

  // Custom categories (customer)
  customCategories: {
    getAll: async () => {
      const response = await api.get('/custom-categories');
      return response.data;
    },

    create: async (data) => {
      const response = await api.post('/custom-categories', data);
      return response.data;
    },

    delete: async (categoryId) => {
      const response = await api.delete(`/custom-categories/${categoryId}`);
      return response.data;
    },
  },

  // Sync Shopify
  syncShopify: async () => {
    const response = await api.post('/admin/sync-shopify');
    return response.data;
  },

  // Upload Images
  uploadImages: async (formData) => {
    const response = await api.post('/upload/product-images', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }
};

export default productsService;
